import React from 'react';
import { enumValue } from '~/util';
import { Notes } from '../Notes';

interface FocGapAuditNotesProps {
    entityId: number;
    gap: GapType;
}
export function FocGapAuditNotes({ entityId, gap }: FocGapAuditNotesProps) {
    return (
        <Notes
            canAdd={false}
            entityId={entityId}
            gap={gap}
            includeActions
            noteEntity="foc_gap.id"
            noteType={enumValue(['note', 'type', 'FOC Gap Note']) as number}
        />
    );
}
